import { render, staticRenderFns } from "./DialogChangeSummary.vue?vue&type=template&id=2608807d&scoped=true"
import script from "./DialogChangeSummary.vue?vue&type=script&lang=js"
export * from "./DialogChangeSummary.vue?vue&type=script&lang=js"
import style0 from "./DialogChangeSummary.vue?vue&type=style&index=0&id=2608807d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608807d",
  null
  
)

export default component.exports